import t from"@emotion/styled";import{setColor as i,setFontSize as o,setFontWeight as l}from"../../utils/generateStyles.js";const r=t.div`
  label: text;
  text-align: ${e=>e.align};
  text-transform: ${e=>e.transform};
  ${e=>i(e.color,"color")};
  ${e=>o(e.size)};
  ${e=>(e.variant==="link"||e.hasUnderline)&&{textDecoration:"underline"}};
  ${e=>l(e.weight)};
  ${e=>e.lineClamp&&{overflow:"hidden",textOverflow:"ellipsis",display:"-webkit-box",WebkitLineClamp:e.lineClamp,WebkitBoxOrient:"vertical"}};
`;export{r as TextStyled};
